var User = require('./src/user');
var Offer = require('./src/offer');
var Service = require('./src/service');
var Offering = require('./src/offering');
var Subscription = require('./src/subscription');

/**
  For method calls that require parameters
    - `company` <> integer -> All methods
    - `userId` <> integer -> For methods that require authorization.
    - `token` <> integer -> For methods that require authorization.
**/
function AhtapotJSGetStarted(parameters){
  var self = this;
}

AhtapotJSGetStarted.prototype.user = function(){
  var self = this;
  return new User(self)
}

AhtapotJSGetStarted.prototype.offer = function(){
  var self = this;
  return new Offer(self)
}

AhtapotJSGetStarted.prototype.service = function(){
  var self = this;
  return new Service(self)
}

AhtapotJSGetStarted.prototype.offering = function(){
  var self = this;
  return new Offering(self)
}

AhtapotJSGetStarted.prototype.subscription = function(){
  var self = this;
  return new Subscription(self)
}



module.exports = AhtapotJSGetStarted;
